import { render } from "./ReleaseForm.vue?vue&type=template&id=5be0291f"
import script from "./ReleaseForm.vue?vue&type=script&lang=js"
export * from "./ReleaseForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__